<template>
  <div class='page-content'>
    <page-template ref="pageTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :addColumns="addColumns"
                   :editColumns="addColumns"
                   :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate
    },
    data() {
      return {
        //搜索框配置
        searchOptions: [
          {label: '应用系统名称', prop: 'name', type: 'input', isFuzzy: true, placeholder: "请输入应用系统名称"},
        ],
        //按钮配置
        toolConfig: [
          {
            label: '添加',
            code: 'insert',
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '编辑',
            code: 'update',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '启动',
            code: 'open',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.status == '关闭'
            },
            callback: this.open
          },
          {
            label: '关闭',
            code: 'close',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.status == '启动'
            },
            callback: this.close
          }
        ],
        // 表格信息配置
        tableOptions: {
          columns: [
            {
              label: 'ID',
              prop: 'id',
              width: '50',
              align: 'center'
            },
            {
              label: '应用系统名',
              prop: 'name',
              width: '150',
              align: 'center',
            },
            {
              label: '应用系统编码',
              prop: 'code',
              width: '150',
              align: 'center'
            },
            {
              label: '保密级别',
              prop: 'security',
              width: '150',
              enumData: [{name: '机密', id: 1}, {name: '秘密', id: 2}, {name: '内部', id: 3}, {name: '公开', id: 4}],
              align: 'center'
            },
            {
              label: '状态',
              prop: 'status',
              width: '150',
              align: 'center'
            },
            {
              label: '备注',
              prop: 'remarks',
              width: '150',
              align: 'center'
            },
            {
              label: '创建人',
              prop: 'user',
              width: '150',
              align: 'center'
            },
            {
              label: '创建时间',
              prop: 'time',
              width: '150',
              align: 'center'
            },
          ],
          param: {},
          url: api.baseInfo.app
        },
        addColumns: {
          span: 12,
          labelWidth: '150px',
          columns: [
            {
              label: '应用系统名称',
              type: 'input',
              prop: 'name',
              rule: [
                {required: true, message: '请输入应用系统名称', trigger: 'blur'},
                {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
              ]
            },
            {
              label: '应用系统编码',
              type: 'input',
              prop: 'code',
              data: [],
              rule: [
                {required: true, message: '请输入应用系统编码', trigger: 'blur'},
                {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
              ]
            },
            {
              label: '保密级别',
              type: 'select',
              prop: 'security',
              data: [{name: '机密', id: 1}, {name: '秘密', id: 2}, {name: '内部', id: 3}, {name: '公开', id: 4}],
              rule: [
                {required: true, message: '请选择保密级别', trigger: 'blur'}]
            },
            {
              label: '备注',
              type: 'input',
              prop: 'remarks'
            }
          ],
          url: api.baseInfo.app
        },
      };
    },
    methods: {
      close(row) {
        this.$axios
          .fetchPost(api.baseInfo.app, {})
          .then(data => {
            if (data.code == 200) {
              row.status = '关闭';
              this.$notify({
                type: "success",
                title: '关闭操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '操作成功！', type: "success"});
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: "请求失败！", type: "error"});
          });
      },
      open(row) {
        this.$axios
          .fetchPost(api.baseInfo.app, {})
          .then(data => {
            if (data.code == 200) {
              row.status = '启动';
              this.$notify({
                type: "success",
                title: '启动操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '操作成功！', type: "success"});
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: "请求失败！", type: "error"});
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/baseInfo/App.vue